import { SelectionModel } from '@angular/cdk/collections';
import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Input,
    OnDestroy,
    OnInit,
    Output,
    ViewChild
} from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { MatTableDataSource } from '@angular/material/table';
import { Subject } from 'rxjs';
import { AppConstants } from '../../../core/app-constants';
import { ApplicationFieldXlatItem } from '../../../core/models/application-field/application-field-xlat-item.model';
import { ApplicationFieldXlat } from '../../../core/models/application-field/application-field-xlat.model';
import { generateRandomString } from '../../../core/pure-functions/generate-random-string.fn';
import { ApplicationFieldItemXlatsFacade } from '../state/application-field-item-xlats/application-field-item-xlats.facade';

@Component({
    selector: 'app-create-application-field-item-xlat',
    templateUrl: './create-application-field-item-xlat.component.html',
    styleUrls: ['./create-application-field-item-xlat.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CreateApplicationFieldItemXlatComponent implements OnInit, OnDestroy {
    private destroy$ = new Subject();

    public selection = new SelectionModel<ApplicationFieldXlatItem>(true);
    public inputPlaceholder = AppConstants.INPUT_PLACEHOLDER;
    public maxLength = 128;
    public applicationFieldItemXlat: ApplicationFieldXlat = {} as ApplicationFieldXlat;

    @Input() public readonlySection: boolean;
    @Input() public sidenav: MatSidenav;
    @Input() public tenantId: string;

    @Output() public closeSidenavClick = new EventEmitter();

    @ViewChild('table') table;

    public dataSource = new MatTableDataSource<ApplicationFieldXlatItem>();
    public displayedColumns: string[] = ['selected', 'valueSource', 'valueTarget'];

    constructor(
        private applicationFieldItemXlatsFacade: ApplicationFieldItemXlatsFacade
    ) { }

    ngOnInit(): void {
        this.applicationFieldItemXlat.tenantId = AppConstants.DEFAULT_TENANT_ID;
        if (this.tenantId) {
            this.applicationFieldItemXlat.tenantId = this.tenantId;
        }
        this.applicationFieldItemXlat.name = '';
        this.applicationFieldItemXlat.type = generateRandomString(5);
        this.applicationFieldItemXlat.valueCase = generateRandomString(5);
        this.applicationFieldItemXlat.valueDefault = generateRandomString(5);
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    public saveApplicationFieldXlatItems(): void {
        this.createApplicationFieldXlatItems(this.dataSource.data);
        this.closeSidenavClick.emit();
    }

    public createApplicationFieldXlatItems(itemsToUpsert: Array<ApplicationFieldXlatItem>): void {
        this.applicationFieldItemXlatsFacade.createApplicationFieldItemXlat(this.applicationFieldItemXlat, itemsToUpsert);
    }

    public deleteXlatRows(): void {
        this.dataSource.data = this.dataSource.data.filter((x) => !this.selection.isSelected(x));
        this.selection.clear();
    }

    public addApplicationFieldXlatItem(): void {
        const newRow = {
            valueSource: '',
            valueTarget: '',
            notation: '',
            tenantId: AppConstants.DEFAULT_TENANT_ID
        } as ApplicationFieldXlatItem;

        this.dataSource.data.push(newRow);
        this.dataSource._updateChangeSubscription();
        this.focusLastRow();
    }

    public showSavePanel(): boolean {
        return !(this.dataSource.data.length === 0) || this.applicationFieldItemXlat.name !== '';
    }

    private focusLastRow(): void {
        this.table?._elementRef.nativeElement
            .getElementsByTagName('tr')
        [this.dataSource.data.length].getElementsByTagName('input')[1]
            .focus();
    }
}
